export default __webpack_public_path__ + "static/media/gallery_05.2190c1e9.jpg";